import { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Navbar, Container, Nav, Image } from "react-bootstrap";
import { NETWORK } from "../../constants";

import "../HeaderTwo/HeaderTwo.css";
import { Alert, Button } from "antd";
import { Web3Context } from "src/contexts";

// Web3

import { WalletBalancesContext } from "src/contexts/WalletBalancesContext";

// 😬 Sorry for all the console logging
const NETWORKCHECK = true;

function HeaderTwo() {
  const { targetNetwork, selectedChainId, localChainId, injectedProvider } =
    useContext(Web3Context);
  // const [displayMessage, setDisplayMessage] = useState(null);

  console.log({ targetNetwork });

  const { eth, weth, gtk, namingCredits } = useContext(WalletBalancesContext);

  const ethBalance = eth.decimal;
  const wethBalance = weth.decimal;
  const goldenTicketBalance = gtk.decimal;
  const namingCreditsBalance = namingCredits.decimal;
  const networkSelected = NETWORK(selectedChainId);

  const displayMessage = useRef(null);

  if (selectedChainId === targetNetwork.chainId) {
    displayMessage.current = null;
  } else if (selectedChainId !== 1) {
    displayMessage.current = (
      <div
        style={{
          zIndex: 2,
          position: "absolute",
          right: 0,
          top: 0,
          padding: 16,
          color: "white",
        }}
        className={`${!selectedChainId ? `d-none` : null}`}
      >
        <Alert
          message="⚠️ Wrong Network"
          description={
            <div>
              You have <b>{networkSelected && networkSelected.name}</b> selected
              and you need to be on{" "}
              <Button
                onClick={async () => {
                  const ethereum = window.ethereum;
                  const data = [
                    {
                      chainId: "0x" + targetNetwork.chainId.toString(16),
                    },
                  ];
                  //  console.log("data", data);
                  const tx = await ethereum
                    .request({
                      method: "wallet_switchEthereumChain",
                      params: data,
                    })
                    .catch(console.error);
                  if (tx) {
                    console.log(tx);
                  }
                }}
              >
                <b>Mainnet</b>
              </Button>
            </div>
          }
          type="error"
          closable={false}
        />
      </div>
    );
  }
  return (
    <header className="header-two" style={{ zIndex: 1, position: "relative" }}>
      <Navbar collapseOnSelect expand="lg">
        <Container>
          <Link to="/" className="navbar-brand">
            <Image src="./img/logo.png" />
          </Link>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mx-auto">
              <div className="specialnavlink">
                <NavLink
                  to="/lets-browse"
                  activeClassName="active"
                  className="text-white nav-link"
                >
                  Browse
                </NavLink>
              </div>
              <div className="specialnavlink">
                <NavLink to="/earn" className="text-white nav-link">
                  Rewards
                </NavLink>
              </div>
              <div className="specialnavlink">
                <NavLink
                  to="/golden-ticket"
                  className="text-white nav-link text-golden"
                >
                  Golden Ticket
                </NavLink>
              </div>
              <div className="specialnavlink">
                <NavLink to="/invite" className="text-white nav-link">
                  Airdrop
                </NavLink>
              </div>
            </Nav>
            <div className="text-center home-button">
              <Link to="/" className="bordered-button pink-border">
                Home
              </Link>
              <div className="waller-wrapper" style={{ marginTop: 15 }}>
                <div className="wallet" id="wallet">
                  {eth.original && (
                    <h4>
                      MY WALLET <Image src="./img/wallet.png" />
                    </h4>
                  )}
                  {gtk.original && (
                    <p>
                      {goldenTicketBalance != null
                        ? goldenTicketBalance.toString()
                        : "..."}{" "}
                      <span className="text-golden">GOLDEN TICKETS</span>
                    </p>
                  )}
                  {ethBalance === null ? null : (
                    <p>
                      {ethBalance.toFixed(4)}{" "}
                      <span className="text-green">ETH</span>
                    </p>
                  )}
                  {wethBalance === null ? null : (
                    <p>
                      {wethBalance.toFixed(4)}{" "}
                      <span className="text-green">WETH</span>
                    </p>
                  )}
                  {namingCreditsBalance === 0 ? null : (
                    <p>
                      {namingCreditsBalance.toFixed(0)}{" "}
                      <span className="text-green">NAMING CREDITS</span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {injectedProvider && displayMessage.current}
    </header>
  );
}

export default HeaderTwo;
